import React from 'react';
import CustomTooltip from '@mui/material/Tooltip'
export const Tooltip = (props) => {
	const { placement, title, children } = props
	return (
        <CustomTooltip
			placement={placement}
			title={title}
			componentsProps={{
				tooltip: {
					sx: {
						backgroundColor: '#ffffff',
						color: 'rgba(0, 0, 0, 0.87)',
						maxWidth: "500px",
						fontSize: "14px",
						padding: "12px",
						border: '1px solid #ddd',
						boxShadow: '0px 0px 15px 1px rgba(0,0,0,0.2)',
					}
				}
			}}
		>
			{children}
		</CustomTooltip>
    );
}
